module.exports = __webpack_public_path__ + "static/doseQ6W-6242bd70be469202186afd78f01d6410.png";